import React from "react";
import MemorialRibbon from "@/components/MemorialRibbon";
import { RotateCcw } from "lucide-react";

const MEMORIAL_NOTE =
  "A total of 2,763 people died at the Twin Towers when they collapsed during the September 11 attacks. This includes 343 firefighters and paramedics, 23 New York City police officers (NYPD), and 37 Port Authority police officers. We will never forget.";

export default function FailScreen({ reason, onReplay }) {
  const cause =
    reason === "breath"
      ? "The smoke and jet-fuel fumes overwhelmed the descent."
      : reason === "stamina"
      ? "Strength gave out amid the hazards of the stairwell."
      : "The South Tower collapsed at 9:59 a.m. — 56 minutes after impact.";
  return (
    <div
      data-testid="fail-screen"
      className="tab-fade"
      style={{ position: "absolute", inset: 0, zIndex: 50, overflowY: "auto" }}
    >
      {/* same American flag entry background at 60% */}
      <div style={{ position: "absolute", inset: 0, backgroundImage: "url(/brand/american_flag.jpg)", backgroundSize: "cover", backgroundPosition: "center", opacity: 0.6 }} />
      <div style={{ position: "absolute", inset: 0, background: "rgba(7,9,13,0.62)" }} />

      <div style={{ position: "relative", zIndex: 1, minHeight: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", gap: 18, padding: "60px 24px 48px", textAlign: "center" }}>
        <div style={{ overflow: "visible", filter: "drop-shadow(0 6px 18px rgba(0,0,0,0.9))" }}>
          <MemorialRibbon size={62} />
        </div>
        <div style={{ fontSize: 11, letterSpacing: "0.32em", textTransform: "uppercase", color: "#b93826" }}>
          Egress Incomplete
        </div>
        <h1 className="font-serif-q" style={{ margin: 0, color: "#ffffff", fontSize: "clamp(34px,6vw,64px)", fontWeight: 700, textShadow: "0 4px 30px rgba(0,0,0,0.85)" }}>
          Historical Outcome
        </h1>
        <p className="font-garamond" style={{ color: "#e6e2d8", fontSize: 17, fontStyle: "italic", maxWidth: 560, lineHeight: 1.6, margin: 0 }}>
          {cause} Stanley Praimnath and Brian Clark were among the last people to escape from at or above
          the impact zone.
        </p>
        <p className="font-garamond" style={{ color: "#cfcabd", fontSize: 15.5, lineHeight: 1.7, maxWidth: 620, margin: "6px 0 4px" }} data-testid="fail-memorial-note">
          {MEMORIAL_NOTE}
        </p>
        <button data-testid="fail-replay-button" onClick={onReplay} className="gold-btn" style={{ padding: "14px 30px", borderRadius: 4, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 9, marginTop: 6 }}>
          <RotateCcw size={16} /> Return to Start
        </button>
      </div>
    </div>
  );
}
